import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
import { DhcpReservationEntity } from '../../../../types/types';
import { formatMacAddress } from '../../../../utils/macFormatter';

interface BulkDhcpReservationSuccessResultProps {
  reservations: DhcpReservationEntity[];
}

const BulkDhcpReservationSuccessResult: React.FC<BulkDhcpReservationSuccessResultProps> = ({
  reservations,
}) => {
  const pluralSuffix = reservations.length !== 1 ? 's' : '';

  return (
    <>
      <CheckCircleIcon sx={{ fontSize: 50, color: green[500], marginTop: 1 }} />
      <Stack spacing={2}>
        <Typography variant="body1">
          {reservations.length} DHCP reservation{pluralSuffix} created successfully!
        </Typography>
        <Box>
          {reservations.map((reservation, index) => (
            <Box key={`${reservation.ip}-${index}`}>
              <Typography variant="body2">
                <Box component="span" fontWeight="bold">
                  {reservation.host}
                </Box>
                {` — IP: ${reservation.ip}, MAC: ${formatMacAddress(reservation.mac)}, interface: ${reservation.interface}`}
              </Typography>
            </Box>
          ))}
        </Box>
      </Stack>
    </>
  );
};

export default BulkDhcpReservationSuccessResult;
